import { Menu } from 'antd';
import React from 'react';

export const MenuDivider: React.FC = () => {
  return <Menu.Divider />;
};
